export default {
  getDocuments: (state) => state.documents,
  getNotifications: (state) => state.notifications,
  getPlan: (state) => state.plan,
  getLinks: (state) => state.links,
  getPagination: (state) => state.pagination,
  getDashboardDetails: (state) => state.dashboardDetails,
};
